import { IBackgroundCheckSettingsResponse } from "@wingspanhq/background-checks/dist/lib/interfaces";

export const getBackgroundChecksDefaultValues = (
  settings: IBackgroundCheckSettingsResponse
) => {
  return {
    instructions: settings.instructions || ""
  };
};
